// Generated by scripts/generate_compatibility.py; do not edit.
// Protocol schema SHA-256: 1b953daf8784762fdca79e064ce26ad698f8252e3f44f7e7bdde318fca204b17
import { RELEASE } from "../release.js";

/** The negotiated declaration, generated from the shared contract. */
export const CLIENT_DECLARATION = {
  "x-recallvault-client": "web",
  "x-recallvault-client-version": "1",
  "x-recallvault-protocol": "2026-08-26"
} as const;

/** What every request sends: the contract declaration plus the commit this bundle was built from. */
export const CLIENT_HEADERS: Record<string, string> = {
  ...CLIENT_DECLARATION,
  "x-recallvault-client-build": RELEASE,
};
